export default {
    page_title: "RFM Analysis",
    legend_frequency_monetary: "Average between frequency and monetary value",
    recency: "Recency",
    last_purchase: "Last purchase",
    range_to: "to",
    purchases: "purchases",
    made_in_last: "Made in the last",
    spent_in_last: "Spent in the last",
    days: "days",
    client: "Client",
    phone: "Phone",
    email: "Email",
    frequency: "Frequency",
    monetary: "Monetary",
    score: "RFM Score",
};
